<template>
  <div>
    <section class="">
        <div class="flex-row section-container flex-justify-center">
            <div class="flex-column flex-item-center flex-grow card-wrapper">
                <h2 class="section-title text-align-center">Background</h2>
                <h3>{{ heroName }}</h3>
            </div>
            <p class="text-align-center hero-bio" v-html="heroBackground"></p>
        </div>
    </section>
    <section class="">
        <div class="flex-row section-container">
            <div class="flex-column flex-item-center flex-grow card-wrapper">
            <h2 class="section-title text-align-center">Unique Attributes</h2>
            <div class="flex-row flex-row-gap card-container">
                    <template v-for="item in cards">
                        <card 
                            class="card landing-cards news-card neutral no-padding">
                            <div class="flex flex-row">
                                <div class="flex-column">
                                    <h3 class="card-title">{{item.title}}</h3>
                                    <ul class="hi-ul odd">
                                        <template v-for="listItem in item.list">
                                            <li class="li-diamond">{{listItem}}</li>
                                        </template>
                                    </ul>
                                </div>
                                <svg-icon-container   
                                    v-if="item.bodySvg"
                                    class="bodySvg"
                                    :hidden="false"
                                    :icon="item.bodySvg">
                                </svg-icon-container>
                            </div>
                        </card>
                    </template>
                </div>
            </div>
        </div>
    </section>
    <section class="">
        <div class="flex-row section-container">
            <div class="flex-column flex-item-center flex-grow card-wrapper">
                <h2 class="section-title text-align-center">Weapons</h2>
                <div class="flex-row flex-row-gap card-container">
                    <template v-for="item in weapons">
                        <card 
                            class="card landing-cards news-card weapon-card neutral no-padding">
                            <div class="flex flex-row flex-justify-center">
                                <div class="flex-column flex-item-center">
                                    <h3 class="card-title">{{item.title}}</h3>
                                    <img class="weapon-img" :src="getImgUrl(item.img)" />
                                </div>
                            </div>
                        </card>
                    </template>
                </div>
            </div>
        </div>
    </section>
    <section class="">
        <div class="flex-row section-container">
            
        </div>
    </section>
    <section id="about" class="">
        <div class="flex-row section-container">
            <div class="flex-column flex-item-center flex-grow card-wrapper width-100">
                <h2 class="section-title text-align-center">Moveset</h2>
            </div>
            <template v-for="move in youTubeVids">
                <div class="flex-row flex-grow flex-item-center text-align-center moveset-container width-100">
                        <div class="flex-column section-info moveset-info flex-1">
                            <p>
                                {{ move.snippet.title }}
                            </p>
                        </div>
                        <div class="flex-column flex-1 video-gallery flex-item-center">
                            <div class="video-container">
                                <div>
                                    <iframe :src="'https://www.youtube.com/embed/' + move.snippet.resourceId.videoId" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                </div>
            </template>
        </div>
    </section>
  </div>
</template>
<script>
import { SvgIconContainer } from "@/components";
import generalServices from '../services/GeneralServices';

const API_KEY = 'AIzaSyD0UfKWgvTfaDK5bq-kgaXa2c48ZDtVZh0';
const PLAYLIST_ID = 'PLXOxTWaPURjFhVBLRUtVnhFZqCAGXzZUe'

export default {
  components: {
    'svg-icon-container': SvgIconContainer,
  },
  mixins: [],
  data() {
    return {
      heroName: "Kyn of Valtoros",
      heroBackground: "The monster Wars played a key role in the dissolution of the Mercurian Commonwealth in the year 150 A.I. and by Imperial Decree, the founding of the Mercurian Empire and its first two Kingdoms. The wars waged for 6 more years until Kyn, the leader of a nomadic desert people, offered their hand. They had an intimate relationship with these Monsters, and that helped them pacify the lands. <br><br>Kyn's tribes, and their cousins from the tundra, were invited into the Empire as the third kingdom, known as the Twin Kingdom. Kyn founded Valtoros within that Twin Kingdom, and settled his people in desert lands similar to their ancient homelands. <br><br> Under Kyn, Valtoros became a vigorous ally of the Empire and became renown for their trade and architecture. But their warrior spirit always remains close to heart. As do their relationship with Monsters. <br><br> Not to say Valtoros could avoid conflict. Before long, their hinterland was being explored by newcomers from the Sea, and a rivalry that would lead to war was soon to follow.",
      cards: [
        {
            'title': 'Desert Folks',
            'list': [
                "2% cheaper buildings",
                "5% slower food gathering"
            ],
        },
        {
            'title': 'Warrior Heritage',
            'list': [
                "20% more attack for all units",
                "2% slower wood gathering"
            ]
        }
      ],
      weapons: [
        {
            'img': 'kynSword',
            'title': 'Sword',
        },
        {
            'img': 'kynSpear',
            'title': 'Spear',
        },
      ],
      youTubeVids: [],
    };
  },
  created () {
    
  },
  mounted() {
    this.getYouTubeVids();
  },
  filters: {
    
  },
  computed: {
    
  },
  methods: {
    getImgUrl(picName) {
        var images = require.context('../assets/img/', false, /\.png$/)
        return images('./' + picName + ".png")
    },
    async getYouTubeVids() {
        try {
            let response = await generalServices.GET_DATA(`https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${PLAYLIST_ID}&maxResults=50&key=${API_KEY}`);
            this.youTubeVids = response.data.items;
        } catch (err) {
            console.log(err);
        }
    },
  }
};</script>
<style lang="scss">
</style>
